import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-konbini-item',
  templateUrl: './konbini-item.component.html',
  styleUrls: ['./konbini-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KonbiniItemComponent {
  // constructor() {}
}
